import React from "react";
import _ from "lodash";
import "./styles.less";

const RadioInput = ({ input, meta: { touched, error }, options }) => {
  /**
   * Handle onChange event
   *
   * @param event
   * @param itemValue
   */
  const onChange = (event, itemValue) => {
    const oldValues = input.value || [];
    let newValues = _.without(oldValues, itemValue); // remove value

    if (event.target.checked) {
      newValues = oldValues.concat(itemValue);
    }
    input.onChange(newValues);
  };

  return (
    <div className="radio-input row">
      {options.map(option => (
        <div className="form-radio col" key={`radio-${option.text}`}>
          <div>
            <input
              name={input.name}
              type="radio"
              checked={input.value && input.value.indexOf(option.value) >= 0}
              onChange={e => onChange(e, option.value)}
            />
            <label htmlFor={option.text}>{option.text}</label>
          </div>
        </div>
      ))}
      <div
        className="errors"
        dangerouslySetInnerHTML={{
          __html: touched && error ? error : "&nbsp;"
        }}
      />
    </div>
  );
};

export default RadioInput;
